import * as Yup from "yup";

export const webhookValidationSchema = Yup.object().shape({
    callback_url: Yup.string().required().label("Url"),
    verify_token: Yup.string().required().label("Webhook"),
});
